module.exports = __webpack_public_path__ + "static/media/TP17.478cd8d9.jpg";